import { Component } from '@angular/core';

@Component({
  selector: 'app-admin-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['../admin-layout.component.scss'],
})
export class CustomersComponent {}
